import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0404 from "../../../lesson/course-04/lesson-04/lesson";
import lesson0407 from "../../../lesson/course-04/lesson-07/lesson";
import lesson0410 from "../../../lesson/course-04/lesson-10/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "7196ad61-4335-4054-8dfa-5ef737e3005e",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "82d21274-832e-4993-907f-ba080b15a26c",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "64dbc142-4b96-49f0-a255-f6a919e64743",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
  {
    id: "30c4d347-4724-4112-98f7-ffa52295d47b",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "859c9ac5-30fa-4b86-8577-19bed4f7dd1a",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0410),
    lesson: lesson0410,
  },
];

export default lessonLinks;
